export default __webpack_public_path__ + "static/media/rider-one-colour.f88aa0c1.svg";